/** Только безопасные статусы подключения; ключи и ответы Ozon сюда не входят.
 * hasSnapshot означает сохранённый срез заказов, включая успешный нулевой.
 * Поле optional в старых ответах: клиент сохраняет прежнее отображение. */
export type StoreDataIssueKind = "missing_key" | "invalid_key" | "refresh_failed" | "not_loaded";
export const STORE_DATA_ISSUE_LABELS: Record<StoreDataIssueKind, string> = {
  missing_key: "API-ключ не подключён", invalid_key: "API-ключ недействителен",
  refresh_failed: "Не удалось обновить данные", not_loaded: "Данные ещё не загружены",
};
export type StoreDataAvailability = {
  issues: { storeId: string; storeName: string; kind: StoreDataIssueKind }[];
  hasSnapshot: boolean;
  updatedAt: number | null;
  canManageKeys: boolean;
};

/** Другие серии могут быть доступны, даже если заказы не обновились. */
export function hasStoreSeriesValues(series: object | null | undefined): boolean {
  return !!series && Object.values(series).some(value => Array.isArray(value)
    && value.some(n => typeof n === "number" && Number.isFinite(n) && n !== 0));
}

export function hasAvailableStoreData(availability: StoreDataAvailability | undefined, series: object | null | undefined): boolean {
  return availability ? availability.hasSnapshot || hasStoreSeriesValues(series) : !!series;
}
